<template>
  <span>
    <slot name="button" v-bind="{ onclick: toggle }">
      <b-button variant="info" class="mr-1" size="xs" @click="toggle"><i class="fas fa-globe"></i>&nbsp;Country</b-button>
    </slot>

    <b-modal
      @show="resetModal"
      @hidden="resetModal"
      ref="modal-container"
      v-model="modalShow"
      size="lg"
      :title="title"
      :static="true"
      :lazy="true"
      hide-footer
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group label="Domain" label-for="enable-domain-input">
          <b-form-input id="enable-domain-input" v-model="formValues.domain" autocomplete="off" disabled />
        </b-form-group>

        <b-form-group label="Country" label-for="enable-country-input">
          <b-form-input
            id="enable-country-input"
            type="text"
            v-model="formValues.country"
            v-validate="{ required: true, min: 2, max: 2 }"
            :state="validateState('country')"
            aria-describedby="enable-country-live-feedback"
            data-vv-name="country"
            data-vv-as="Country"
            autocomplete="off"
            maxlength="2"
            placeholder="DE"
            required
          />
          <b-form-invalid-feedback id="enable-country-live-feedback">{{ veeErrors.first('country') }}</b-form-invalid-feedback>
        </b-form-group>
      </form>

      <b-button class="mt-2 float-right" variant="primary" @click="handleSubmit">Save</b-button>
    </b-modal>
  </span>
</template>

<script>
import Vue from "vue";

export default {
  data() {
    return {
      modalShow: false,
      formValues: this.getInitialValues(),
    }
  },
  props: {
    title: String,
    domain: String,
    operator: String,
    order: [Number, String],
  },
  methods: {
    getInitialValues() {
      return {
        domain: null,
        country: null,
      };
    },
    setDefaults() {
      let initialValues = this.getInitialValues();
      for (let field in initialValues) {
        Vue.set(this.formValues, field, initialValues[field]);
      }
      Vue.set(this.formValues, 'domain', this.domain);
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    resetModal() {
      this.setDefaults();
    },
    hideModal() {
      this.$refs['modal-container'].hide();
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
    handleSubmit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        const country = (this.formValues.country || '').trim().toUpperCase();

        this
          .$http({
            url: '/api/v1/proxy-domains/enable',
            data: {
              domain: this.formValues.domain,
              country,
              operator: this.operator || 'all',
              order: this.order === null || this.order === undefined || this.order === ''
                ? null
                : Number.parseInt(this.order, 10),
            },
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then(() => {
            setTimeout(() => {
              this.$emit('finish');
            }, 500);

            this.hideModal();
            this.$toastr.i('Success');
          })
          .catch((err) => {
            let message;
            if (typeof err.response.data.message === 'string') {
              message = err.response.data.message;
            } else {
              message = JSON.stringify(err.response.data.message);
            }
            this.$toastr.e(message);
            throw err;
          });
      });
    },
  },
  mounted() {
    this.setDefaults();
  },
}
</script>
